module.exports = __webpack_public_path__ + "static/media/backarrow.1ff7b674.svg";